import { Text, type TextProps } from '../Text'
import { tagLabelLarge, tagLabelSmall, tagLabelStyle } from './TagLabel.css'

enum TagLabelKind {
  New = 'new',
  Internal = 'internal',
  Subtle = 'subtle',
}

type Props = TextProps & {
  kind?: `${TagLabelKind}`
  onClick?: undefined // hint that Labels like this are not clickable
}

export const TagLabel = ({
  kind = TagLabelKind.New,
  className,
  children = 'New',
  size = 's',
  ...props
}: Props) => (
  <Text
    as="span"
    borderRadius="rounded"
    background="secondary"
    size="xs"
    color={kind === TagLabelKind.Subtle ? 'secondary' : 'highlight'}
    textAlign="center"
    fontWeight="400"
    className={[
      tagLabelStyle,
      {
        [tagLabelSmall]: size === 's' || size === 'xs',
        [tagLabelLarge]: size === 'm',
      },
      className,
    ]}
    {...(kind === TagLabelKind.Internal ? { 'data-internal': true } : null)}
    {...props}
  >
    {children}
  </Text>
)

TagLabel.displayName = 'TagLabel'
